import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const adsManagementApi = {
  getAdsManagement: (request) => {
    const { params } = request
    const url = `/ads-management`
    return instance().get(url, { params })
  },
  postAdsManagement: (request) => {
    const { data } = request
    const url = `/ads-management`
    return instance().post(url, data)
  },
  putAdsManagement: (request) => {
    const { data } = request
    const url = `/ads-management`
    return instance().put(url, data)
  },
  deleteAdsManagement: (request) => {
    const { data } = request
    const url = `/ads-management`
    return instance().delete(url, {
      data
    })
  }
}

export default adsManagementApi



// WEBPACK FOOTER //
// ./src/api/ads-management.js